import './mocks.css';

/* The niroggyan mark; `className` sizes it (fill is currentColor). */
export function BrandMark({ className = 'report-cover__mark' }) {
  return (
    <svg className={className} viewBox="0 0 27 27" aria-hidden="true" focusable="false">
      <path d="M13.37 13.38v13.38C5.99 26.76 0 20.77 0 13.38h13.37Z" opacity=".55" />
      <path d="M13.37 13.38H0V0c7.38 0 13.37 5.99 13.37 13.38Z" />
      <path d="M26.74 13.38c0 7.39-5.99 13.38-13.37 13.38 0-7.39 5.99-13.38 13.37-13.38Z" />
      <path d="M26.74 13.38c-7.38 0-13.37-5.99-13.37-13.38 7.38 0 13.37 5.99 13.37 13.38Z" opacity=".55" />
    </svg>
  );
}

/*
 * The first page of a smart report, rebuilt in HTML. `accent` recolours the
 * brand mark and title rule (used by the brand-equity screen). Synthetic data.
 */
export default function ReportCover({
  title = 'Smart Health Report',
  brand = 'niroggyan',
  patient = 'Patient A',
  details = 'Female | 30 years',
  date = 'Test date: 12 Oct 2024',
  accent,
  children,
  className,
}) {
  return (
    <article
      className={className ? `report-cover ${className}` : 'report-cover'}
      style={accent ? { '--report-accent': accent } : undefined}
    >
      <header className="report-cover__head">
        <span className="report-cover__brand">
          <BrandMark />
          {brand}
        </span>
        <span className="report-cover__patient">
          <strong>{patient}</strong>
          <span>{details}</span>
          <span>{date}</span>
        </span>
      </header>
      <h3 className="report-cover__title">{title}</h3>
      {children && <div className="report-cover__body">{children}</div>}
    </article>
  );
}
